module.exports = __webpack_public_path__ + "static/media/elephant.61192117.png";